function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { useSdkContext } from "~/components/contexts";
import { FacebookUrl, InstagramUrl, LinkedinUrl, TwitterUrl, YoutubeUrl } from "./consts";
import { SocialMedia as SocialMediaEnum } from "./enums";
var FacebookIcon = function FacebookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2.696 18V9.95H0v-3.2h2.696V4.23C2.696 1.49 4.37 0 6.813 0 7.984 0 8.99.088 9.281.127v2.861H7.587C6.257 2.988 6 3.621 6 4.546V6.75h3l-.411 3.2H6V18"
  }));
};
FacebookIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "18",
  viewBox: "0 0 10 18"
};
var InstagramIcon = function InstagramIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-3-3h24v24H-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 1.624c2.402 0 2.687.01 3.636.052.877.04 1.353.187 1.67.31.392.144.746.374 1.036.673.3.29.53.645.673 1.036.124.317.27.794.31 1.67.043.95.053 1.234.053 3.636 0 2.403-.01 2.687-.053 3.636-.04.877-.186 1.354-.31 1.67a2.982 2.982 0 0 1-1.707 1.708c-.317.124-.794.27-1.67.31-.95.043-1.234.053-3.637.053-2.402 0-2.687-.01-3.635-.053-.877-.04-1.354-.186-1.671-.31a2.786 2.786 0 0 1-1.036-.673 2.777 2.777 0 0 1-.673-1.036c-.123-.317-.27-.793-.31-1.67-.043-.95-.052-1.233-.052-3.636 0-2.402.01-2.687.052-3.636.04-.877.187-1.353.31-1.67.144-.392.374-.746.673-1.036.29-.3.645-.53 1.036-.673.317-.124.794-.27 1.67-.31.95-.043 1.234-.052 3.636-.052H9zM9.001 0c-2.443 0-2.75.01-3.71.055C4.333.1 3.68.253 3.108.475c-.6.226-1.144.58-1.594 1.038-.458.45-.812.994-1.038 1.594C.253 3.68.101 4.334.057 5.291.014 6.25.003 6.556.003 9s.01 2.75.054 3.71.196 1.611.418 2.183c.226.6.58 1.144 1.038 1.593.45.458.994.813 1.594 1.039.572.222 1.227.374 2.184.418.958.043 1.266.054 3.71.054 2.443 0 2.75-.01 3.71-.054.959-.044 1.61-.196 2.182-.418a4.598 4.598 0 0 0 2.632-2.632c.222-.572.374-1.227.418-2.184.043-.958.054-1.266.054-3.71 0-2.443-.01-2.75-.054-3.71-.044-.959-.196-1.61-.418-2.182a4.411 4.411 0 0 0-1.038-1.593A4.417 4.417 0 0 0 14.893.475C14.32.253 13.666.101 12.709.057 11.75.014 11.444.003 9 .003L9.001 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4.38a4.62 4.62 0 1 0 0 9.24 4.62 4.62 0 0 0 0-9.24zM9 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "13.803",
    cy: "4.197",
    r: "1.08"
  }));
};
InstagramIcon.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
};
var LinkedinIcon = function LinkedinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.846 6.611V19.75H.482V6.611h4.364zm.279-4.086c0 .681-.217 1.223-.65 1.625-.495.433-1.099.65-1.811.65-.743 0-1.331-.217-1.764-.65-.433-.402-.65-.944-.65-1.625S.467 1.302.9.9C1.395.467 1.999.25 2.711.25c.681 0 1.269.217 1.764.65.433.433.65.975.65 1.625zm15.461 9.657v7.568h-4.364v-7.057c0-.929-.17-1.656-.511-2.182-.371-.526-.929-.789-1.671-.789-.526 0-.99.155-1.393.464-.402.31-.696.696-.882 1.161-.093.248-.139.604-.139 1.068v7.336H7.262c.031-2.352.046-5.215.046-8.589V7.216l-.046-.604h4.364v1.904c.31-.464.48-.712.511-.743.155-.217.418-.449.789-.696.31-.248.681-.449 1.114-.604.402-.124.913-.186 1.532-.186 1.517 0 2.739.495 3.668 1.486.898.99 1.346 2.461 1.346 4.411z"
  }));
};
LinkedinIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "20",
  viewBox: "0 0 21 20"
};
var TwitterIcon = function TwitterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20 2c-.6.8-1.3 1.5-2 2v.6c0 1.2-.2 2.3-.5 3.3C17.2 9 16.7 10 16 11c-.5.9-1.3 1.8-2.3 2.7-1 .8-2.1 1.4-3.3 1.9-1.2.4-2.6.7-4.1.7-2.3 0-4.4-.7-6.3-1.9.4.1.7.1 1 .1 1.8 0 3.6-.6 5.1-1.8-.9 0-1.7-.3-2.4-.8s-1.2-1.2-1.5-2c.4 0 .7.1.8.1.4 0 .8-.1 1.1-.2-.9-.2-1.7-.7-2.4-1.4-.6-.8-.9-1.6-.9-2.6v-.1c.6.4 1.2.5 1.9.5-.6-.3-1-.8-1.4-1.4-.3-.6-.5-1.2-.5-2 0-.7.2-1.4.6-2 1 1.2 2.3 2.2 3.7 3 1.5.7 3.1 1.2 4.8 1.3-.1-.4-.2-.7-.2-1 0-1.1.4-2.1 1.2-2.9.8-.8 1.8-1.2 3-1.2s2.2.4 3 1.3c.9-.2 1.8-.5 2.6-1-.3 1-.9 1.7-1.8 2.3.7-.1 1.5-.3 2.3-.6z"
  }));
};
TwitterIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "17",
  viewBox: "0 0 20 17"
};
var YoutubeIcon = function YoutubeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.99 9.71c.284-.158.426-.395.426-.71 0-.316-.142-.553-.426-.71l-6.914-4.357c-.284-.189-.584-.189-.9 0-.284.158-.426.41-.426.758v8.619c0 .347.142.6.426.758a.69.69 0 0 0 .426.142.912.912 0 0 0 .474-.142l6.914-4.357zm7.341-2.747v4.073c0 .474-.047 1.089-.142 1.847-.032.758-.126 1.421-.284 1.989a3.243 3.243 0 0 1-.947 1.658c-.442.442-.995.71-1.658.805-2.368.221-5.399.332-9.093.332s-6.725-.111-9.093-.332c-.663-.095-1.216-.363-1.658-.805a3.236 3.236 0 0 1-.947-1.658c-.158-.568-.253-1.231-.284-1.989a15.477 15.477 0 0 1-.142-1.847V6.963c0-.474.047-1.089.142-1.847.032-.758.126-1.421.284-1.989a3.243 3.243 0 0 1 .947-1.658c.442-.442.995-.71 1.658-.805C5.482.443 8.513.332 12.207.332s6.725.111 9.093.332c.663.095 1.216.363 1.658.805.474.442.789.995.947 1.658.158.568.253 1.231.284 1.989.095.758.142 1.373.142 1.847z"
  }));
};
YoutubeIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "18",
  viewBox: "0 0 25 18"
};
import { Container, IconContainer } from "./styles";
export const SocialMedia = ({
  ...props
}) => {
  const {
    handleTrackGA,
    handleTrackGA4
  } = useSdkContext();
  const socialMediaMap = {
    [SocialMediaEnum.Facebook]: {
      icon: FacebookIcon,
      url: FacebookUrl
    },
    [SocialMediaEnum.Instagram]: {
      icon: InstagramIcon,
      url: InstagramUrl
    },
    [SocialMediaEnum.Linkedin]: {
      icon: LinkedinIcon,
      url: LinkedinUrl
    },
    [SocialMediaEnum.Twitter]: {
      icon: TwitterIcon,
      url: TwitterUrl
    },
    [SocialMediaEnum.Youtube]: {
      icon: YoutubeIcon,
      url: YoutubeUrl
    }
  };
  const renderIcon = media => {
    const {
      icon: Component,
      url
    } = socialMediaMap[media];
    return /*#__PURE__*/React.createElement(IconContainer, {
      key: media,
      "data-qa": "render-icon"
    }, /*#__PURE__*/React.createElement("a", {
      href: url,
      rel: "noopener noreferrer",
      target: "_blank",
      title: "Follow SCMP",
      onClick: () => {
        const map = {
          facebook: "Facebook",
          instagram: "Instagram",
          linkedin: "LinkedIn",
          twitter: "Twitter",
          youtube: "Youtube"
        };
        handleTrackGA4({
          action: "click",
          category: "footer",
          customized_parameters: {
            destination_url: url,
            link_name: media,
            social_platform: media
          },
          subcategory: ""
        });
        return handleTrackGA({
          action: "Footer/Stay Connected/Click",
          category: "Footer",
          label: `Footer/Stay Connected/${map[media]}`
        });
      }
    }, /*#__PURE__*/React.createElement(Component, null)));
  };
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    "data-qa": "social-media"
  }), [SocialMediaEnum.Facebook, SocialMediaEnum.Twitter, SocialMediaEnum.Youtube, SocialMediaEnum.Instagram, SocialMediaEnum.Linkedin].map(media => renderIcon(media)));
};
SocialMedia.displayName = "SocialMedia";